import { Box, styled } from "@mui/material";
const ScrollRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "canScroll"
})(({ canScroll }) => ({
  flex: "0 1 auto",
  width: "100%",
  height: canScroll ? "100%" : void 0,
  display: "flex",
  position: "relative",
  flexDirection: "column"
}));
export {
  ScrollRoot
};
//# sourceMappingURL=ScrollRoot.js.map
